"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Data: function() {
        return Data;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Data = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M22.2311 5.75305C22.2311 5.75305 22.2422 5.65294 22.2422 5.59732C22.2422 3.27252 17.2033 2.06006 12.2311 2.06006C7.25893 2.06006 2.22 3.28364 2.22 5.59732C2.22 5.66406 2.22 5.74193 2.23112 5.80867C2.23112 5.80867 2.22 5.87541 2.22 5.89766V18.2225C2.22 18.4783 2.27562 18.7341 2.36461 18.9566C2.36461 18.9566 2.36831 18.9566 2.37573 18.9566C3.26561 21.0033 7.77061 22.0601 12.2311 22.0601C16.6916 22.0601 21.1855 21.0033 22.0865 18.9566H22.0976C22.1866 18.7341 22.2422 18.4783 22.2422 18.2225V5.90878C22.2422 5.90878 22.2422 5.84204 22.2311 5.81979V5.75305ZM20.5292 18.2336C20.5292 19.1568 17.2256 20.5473 12.2311 20.5473C7.23669 20.5473 3.93302 19.1568 3.93302 18.2336V16.1757C5.83513 17.2213 9.04981 17.7664 12.2311 17.7664C15.4124 17.7664 18.6271 17.2213 20.5292 16.1757V18.2336ZM20.5292 13.9177C20.5292 14.8409 17.2256 16.2314 12.2311 16.2314C7.23669 16.2314 3.93302 14.8409 3.93302 13.9177V11.8598C5.83513 12.9054 9.04981 13.4505 12.2311 13.4505C15.4124 13.4505 18.6271 12.9054 20.5292 11.8598V13.9177ZM20.5292 9.60177C20.5292 10.525 17.2256 11.9155 12.2311 11.9155C7.23669 11.9155 3.93302 10.525 3.93302 9.60177V7.66629C5.83513 8.64515 9.04981 9.13459 12.2311 9.13459C15.4124 9.13459 18.6271 8.64515 20.5292 7.66629V9.60177ZM12.2311 7.59955C6.75838 7.59955 3.93302 6.19799 3.93302 5.59732C3.93302 4.99665 6.75838 3.5951 12.2311 3.5951C17.7039 3.5951 20.5292 4.99665 20.5292 5.59732C20.5292 6.19799 17.715 7.59955 12.2311 7.59955Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M21.9642 18.7453V19.079C21.9642 19.2569 21.9085 19.4127 21.8196 19.5462C21.9085 19.3014 21.9642 19.0234 21.9642 18.7453Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M2.64269 19.5462C2.55371 19.4127 2.49809 19.2569 2.49809 19.079V18.7453C2.49809 19.0234 2.55371 19.3014 2.64269 19.5462Z",
            fill: "currentColor"
        })
    ]
}), "Data");
const _default = Data;
